import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteProject = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#EE6363" }, /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 9, r: 9, strokeWidth: 1.2 }), /* @__PURE__ */ React.createElement("path", { fill: "#EE6363", strokeWidth: 0.2, d: "M2.301 15.029L15.03 2.301l.67.67L2.97 15.699z" })));
const ForwardRef = forwardRef(SvgDeleteProject);
export { ForwardRef as ReactComponent };
